import { render, staticRenderFns } from "./InterstitialMaterial.vue?vue&type=template&id=4240e1ee&scoped=true"
import script from "./InterstitialMaterial.vue?vue&type=script&lang=js"
export * from "./InterstitialMaterial.vue?vue&type=script&lang=js"
import style0 from "./InterstitialMaterial.vue?vue&type=style&index=0&id=4240e1ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4240e1ee",
  null
  
)

export default component.exports